export default "__VITE_ASSET__Cc2vqZqu__";